import { useEffect } from 'react';
import type { NetworkPointDetail } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export type NetworkPointParams = {
  'include-links'?: boolean;
};

type Options = {
  oldNetworkPointId: number | string | undefined;
  params?: NetworkPointParams;
};

export function useNetworkPoint({ oldNetworkPointId, params }: Options) {
  const networkPoint = useAxios(
    async (
      axios,
      baseConfig,
      id: number | string,
      params?: NetworkPointParams
    ) =>
      axios.request<NetworkPointDetail>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/networkPoints/${id}`,
        method: 'GET',
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!oldNetworkPointId) return;

    networkPoint.execute(oldNetworkPointId, params);
    // oxlint-disable-next-line exhaustive-deps
  }, [oldNetworkPointId, params]);

  return networkPoint;
}

export type NetworkPointRequest = ReturnType<typeof useNetworkPoint>;
